import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import { createCompany } from '../../services/Company/companyService';
import ErrorModal from '../Modals/ErrorModal';
import SuccessModal from '../Modals/SuccessModal';
import InputField from '../Utils/InputField';
import UFSelect from '../Utils/UFSelect';
import DocumentInput from '../Utils/DocumentInput';
import PhoneInput from '../Utils/PhoneInput';
import ZipCodeInput from '../Utils/ZipCodeInput';

const CreateCompanyModal = ({ show, handleClose, refreshCompanies, onCreated }) => {
  const { register, handleSubmit, formState: { errors }, reset, control } = useForm();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const onSubmit = async (data) => {
    try {
      const created = await createCompany(data);
      
      if (onCreated) {
        onCreated({
          id: created.uuid,
          name: created.name,
          discount: created.discount,
        });
      } else {
        setSuccessMessage('Empresa criada com sucesso!');
        setShowSuccessModal(true);
      }

      reset();
    } catch (error) {
      setErrorMessage(error.message || 'Erro ao criar empresa.');
      setShowErrorModal(true);
    }
  };

  const handleCloseErrorModal = () => setShowErrorModal(false);
  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    refreshCompanies();
    handleClose();
  };

  useEffect(() => {
    if (show) {
      reset();
    }
  }, [show, reset]);

  return (
    <>
      <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Cadastrar Empresa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={(e) => {
              e.stopPropagation();
              handleSubmit(onSubmit)(e);
            }}
          >
            <Row>
              <Col md={8}>
                <InputField
                  label="Nome"
                  name="name"
                  placeholder="Digite o nome"
                  register={register}
                  errors={errors}
                  rules={{ required: 'Nome é obrigatório' }}
                />
              </Col>
              <Col md={4}>
                <DocumentInput
                  label="CPF/CNPJ"
                  name="document"
                  register={register}
                  errors={errors}
                  rules={{ required: 'Documento é obrigatório' }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <InputField
                  label="Inscr. Estadual"
                  name="registration"
                  placeholder="Digite a Inscrição Estadual"
                  register={register}
                  errors={errors}
                />
              </Col>
              <Col md={6}>
                <PhoneInput
                  label="Telefone Comercial"
                  name="businessPhone"
                  register={register}
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <PhoneInput
                  label="Telefone Celular"
                  name="cellPhone"
                  register={register}
                  errors={errors}
                />
              </Col>
              <Col md={6}>
                <ZipCodeInput
                  label="CEP"
                  name="zipCode"
                  register={register}
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <InputField
                  label="Endereço"
                  name="address"
                  placeholder="Digite o endereço"
                  register={register}
                  errors={errors}
                />
              </Col>
              <Col md={6}>
                <InputField
                  label="Bairro"
                  name="district"
                  placeholder="Digite o bairro"
                  register={register}
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <InputField
                  label="Cidade"
                  name="city"
                  placeholder="Digite a cidade"
                  register={register}
                  errors={errors}
                  rules={{ required: 'Cidade é obrigatória' }}
                />
              </Col>
              <Col md={6}>
                <Controller
                  name="state"
                  control={control}
                  defaultValue=""
                  rules={{ required: 'Estado é obrigatório' }}
                  render={({ field, fieldState }) => (
                    <UFSelect
                      label="Estado"
                      name="state"
                      register={register}
                      errors={errors}
                    />
                  )}
                />
              </Col>
            </Row>
            <Button variant="primary" className="button-custom w-100 mt-3" type="submit">
              Cadastrar
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <ErrorModal
        show={showErrorModal}
        handleClose={handleCloseErrorModal}
        errorMessage={errorMessage}
      />

      <SuccessModal
        show={showSuccessModal}
        handleClose={handleCloseSuccessModal}
        successMessage={successMessage}
      />
    </>
  );
};

export default CreateCompanyModal;